import { Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import ImageOnLoad from "components/ImageOnLoad";
import noResult from "assets/images/no-results.gif";

const ImageOnLoadStyled = styled(ImageOnLoad)({
  display: "block",
  margin: "50px auto",
});

const StinkyBox = () => {
  return (
    <Container>
      <ImageOnLoadStyled src={noResult} alt="no results" width={240} widthMobile={240} />
      <Typography variant="h2" align="center">
        Oh poop! This stinks. No Results Found.
      </Typography>
    </Container>
  );
};

export default StinkyBox;
